<template>
  <div class="h-screen">

    <section class="px-5 lg:px-8 mt-10 mb-6">
      <div class="flex flex-col md:flex-row justify-between items-center p-5 lg:p-8 bg-white shadow-lg rounded-lg">
        <span>
          <h1 class="text-oxford-blue mb-2 text-3xl font-semibold">{{ translate('my invitations', 'ucfirst') }}</h1>
          <p class="text-base text-gray-500 font-normal">{{ translate('manage company invitations', 'ucfirst') }}</p>
        </span>
      </div>
    </section>

    <Dialog v-model:visible="visible" modal :header="translate('my invitations', 'ucfirst')" :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <ul>
        <li class="flex justify-between text-oxford-blue font-semibold px-5 py-3 mb-1.5 bg-sea-serpent gray-200">
          <h3 class="w-1/3">{{ translate('Company', 'ucfirst') }}</h3>
          <h3 class="w-1/3 md:pl-4">{{ translate('Contact', 'ucfirst') }}</h3>
          <h3 class="w-1/3 md:pl-4">{{ translate('Status', 'ucfirst') }}</h3>
          <h3 class="w-1/5 md:pl-4">{{ translate('Add at', 'ucfirst') }}</h3>
          <h3 class="w-1/6 md:pl-4">{{ translate('Actions', 'ucfirst') }}</h3>
        </li>

        <template v-if="filteredInvitations.length">
          <li v-for="(invitation, index) in filteredInvitations" :key="index"
            class="flex justify-between items-center p-3 border-b border-iron">
            <div class="flex items-center gap-3 w-1/3">
              <img src="@/assets/images/avatar.png" class="w-9 rounded-full" />
              <span>
                <h2 class="text-oxford-blue font-medium">{{ invitation.person_username || '-' }}</h2>
                <small class="text-sm text-gray-500 font-normal">{{ invitation.person_email || '-' }}</small>
              </span>
            </div>
            <p class="flex items-center px-4 w-1/5">
              {{ invitation.person_ddi || '' }} {{ invitation.person_phone || '' }}
            </p>
            <span class="px-4 w-1/3">
              <Tag :value="invitation.status" :severity="invitation.status == 'active' ? 'success' : 'danger'" class="m-1" />
            </span>
            <strong class="flex items-center px-4 w-1/5">{{ invitation.created_at || '-' }}</strong>
            <span class="flex flex-wrap items-center px-4 w-1/6">
              <Tag @click="refuseInvitation(invitation.company_recruiter_id)" class="m-1 cursor-pointer"
                icon="pi pi-trash" value="Recusar" severity="danger" />
              <Tag @click="acceptInvitation(invitation.company_recruiter_id)" class="m-1 cursor-pointer"
                icon="pi pi-check" value="Aceitar" severity="success" />
            </span>
          </li>
        </template>

        <template v-else>
          <li class="flex justify-center items-center py-6 text-gray-500 font-medium">
            {{ translate('no invitations received', 'ucfirst') }}
          </li>
        </template>
      </ul>
    </Dialog>

    <!-- Lista de Recrutadores -->
    <section class="w-full lg:px-8 mb-20">
      <div class="bg-white shadow-lg rounded-lg overflow-hidden">
        <ul>
          <li class="flex justify-between text-oxford-blue font-semibold px-5 py-3 mb-1.5 bg-sea-serpent gray-200">
            <h3 class="w-1/3">{{ translate('Company', 'ucfirst') }}</h3>
            <h3 class="w-1/3 md:pl-4">{{ translate('Contact', 'ucfirst') }}</h3>
            <h3 class="w-1/3 md:pl-4">{{ translate('Status', 'ucfirst') }}</h3>
            <h3 class="w-1/5 md:pl-4">{{ translate('Add at', 'ucfirst') }}</h3>
            <h3 class="w-1/6 md:pl-4">{{ translate('Actions', 'ucfirst') }}</h3>
          </li>

          <template v-if="filteredInvitations.length">
            <li v-for="(invitation, index) in filteredInvitations" :key="index"
              class="flex justify-between items-center p-3 border-b border-iron">
              <div class="flex items-center gap-3 w-1/3">
                <img src="@/assets/images/avatar.png" class="w-9 rounded-full" />
                <span>
                  <h2 class="text-oxford-blue font-medium">{{ invitation.person_username || '-' }}</h2>
                  <small class="text-sm text-gray-500 font-normal">{{ invitation.person_email || '-' }}</small>
                </span>
              </div>
              <p class="flex items-center px-4 w-1/5">{{ invitation.person_ddi || '' }} {{ invitation.person_phone || '' }}</p>
              <span class="px-4 w-1/3">
                <Tag :value="invitation.status" :severity="invitation.status == 'active' ? 'success' : 'danger'" class="m-1" />
              </span>
              <strong class="flex items-center px-4 w-1/5">{{ invitation.created_at || '-' }}</strong>
              <span class="flex flex-wrap items-center px-4 w-1/6">
                <Tag @click="refuseInvitation(invitation.company_recruiter_id)" class="m-1 cursor-pointer"
                  icon="pi pi-trash" value="Recusar" severity="danger" />
                <Tag @click="acceptInvitation(invitation.company_recruiter_id)" class="m-1 cursor-pointer"
                  icon="pi pi-check" value="Aceitar" severity="success" />
              </span>
            </li>
          </template>

          <template v-else>
            <li class="flex justify-center items-center py-6 text-gray-500 font-medium">
              {{ translate('no invitations received', 'ucfirst') }}
            </li>
          </template>
        </ul>
      </div>
    </section>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import Dialog from 'primevue/dialog';
import Tag from 'primevue/tag';
import requestHandler from '@/composables/requestHandler';
import { translate } from '@/composables/translate';
import { showToast } from '@/composables/toast';


// ############ Declaração de variáveis ############
const visible = ref(false);
const myInvitations = ref([]);
const loading = ref(false);
const toast = useToast();

// Computed para garantir dados válidos
const filteredInvitations = computed(() =>
  (myInvitations.value || []).filter(invite =>
    invite && typeof invite === 'object' && invite.person_username
  )
);

// Carrega convites do recrutador
async function getMyInvitations() {
  loading.value = true;
  const response = await requestHandler.executeRequest("api/recruiter/myinvitations", {}, "get");
  loading.value = false;

  if (!response.success) {
    showToast(toast, response.message, "error");
    return;
  }

  // Corrigido: acessar o campo correto da resposta
  const data = response.data && response.data.data ? response.data.data : [];
  if (Array.isArray(data)) {
    myInvitations.value = data;
  } else if (data && typeof data === 'object') {
    myInvitations.value = [data];
  } else {
    myInvitations.value = [];
  }
}

// Aceita convite
async function acceptInvitation(recruiterId) {
  loading.value = true;
  const response = await requestHandler.executeRequest("api/recruiter/acceptinvitation", { recruiter_id: recruiterId });
  loading.value = false;

  showToast(toast, response.message, response.success ? "success" : "error");
  getMyInvitations();
}

// Recusa convite
async function refuseInvitation(recruiterId) {
  loading.value = true;
  const response = await requestHandler.executeRequest("api/recruiter/refuseinvitation", { recruiter_id: recruiterId });
  loading.value = false;

  showToast(toast, response.message, response.success ? "success" : "error");
  getMyInvitations();
}

// ############ Hooks ############


onMounted(() => {
  getMyInvitations();
});
</script>